var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_vm._m(0),_c('TechSwiper')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container",attrs:{"data-aos":"fade-up"}},[_c('div',{staticClass:"english-title"},[_vm._v("PRODUCT")]),_c('div',{staticClass:"chinese-title"},[_c('div',{staticClass:"title"},[_vm._v("创世产品技术")]),_c('div',{staticClass:"desc"},[_vm._v("深耕IT前沿技术，打造先进平台及产品")])])])
}]

export { render, staticRenderFns }